<template>
  <nav class="header-navbar navbar navbar-with-menu navbar-fixed-top navbar-semi-dark navbar-shadow">
      <div class="navbar-wrapper">
        <div class="navbar-header">
          <ul class="nav navbar-nav">
            <li class="nav-item mobile-menu hidden-md-up float-xs-left">
              <a class="nav-link nav-menu-main menu-toggle hidden-xs">
                <i class="icon-menu5 font-large-1"></i>
              </a>
            </li>
            <li class="nav-item">
              <div class="navbar-brand nav-link">
                <!--<img v-if="$store.state.menuOpened" alt="ME" :src="big_logo" style="max-width: 100%">
                <img v-else alt="ME" :src="small_logo" style="width: 2rem">-->

                <!-- <div id="menu_logo" class="brand-logo"></div> -->
                <svg id="menu_logo" class="brand-logo"/>
                </div>
            </li>
            <li class="nav-item hidden-md-up float-xs-right">
              <a data-toggle="collapse" data-target="#navbar-mobile" class="nav-link open-navbar-container">
                <i class="icon-ellipsis pe-2x icon-icon-rotate-right-right"></i>
              </a>
            </li>
          </ul>
        </div>
        <div class="navbar-container content container-fluid">
          <div id="navbar-mobile" class="collapse navbar-toggleable-sm">
            <ul class="nav navbar-nav">
              <li class="nav-item hidden-sm-down" @click="$store.state.menuOpened = !$store.state.menuOpened">
                <a class="nav-link nav-menu-main menu-toggle hidden-xs">
                  <i class="icon-menu5"></i>
                </a>
              </li>

              <li class="nav-item dropdown">
                <a class="nav-link menu-toggle"><i class="icon-office"></i>{{$store.state.clientName}}</a>
              </li>

            </ul>

            <ul class="nav navbar-nav float-xs-right">
              <li class="dropdown dropdown-language nav-item">
                <a id="dropdown-flag" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="dropdown-toggle nav-link">
                
                  <i ref="lang_btn" class="flag-icon" :class="$i18n.tc('lang.logo', $i18n.locale )"></i>
                  <span class="selected-language"> {{$i18n.tc('lang.title', $i18n.locale )}}</span>
                </a>
                
                <div aria-labelledby="dropdown-flag" class="dropdown-menu">
                  <a class="dropdown-item" :id="item.lang" v-for="item in listLanguages" :key="item.id" @click="changeLanguage(item.lang)">
                    <i class="flag-icon" :class="$i18n.getLocaleMessage(item.lang).lang.logo"></i> {{ $i18n.getLocaleMessage(item.lang).lang.title }}
                  </a>

                  <!--<a class="dropdown-item" @click="changeLanguage('en')"><i class="flag-icon flag-icon-gb"></i> {{ this.$i18n.messages.en.lang.title }}</a>
                  <a class="dropdown-item" @click="changeLanguage('ua')"><i class="flag-icon flag-icon-ua"></i> {{ this.$i18n.messages.ua.lang.title }}</a>
                  <a class="dropdown-item" @click="changeLanguage('ru')"><i class="flag-icon flag-icon-ru"></i> {{ this.$i18n.messages.ru.lang.title }}</a>
                  -->
                </div>
              </li>
              
              <li class="dropdown dropdown-user nav-item">
                <a id="dropdown_usr" data-toggle="dropdown" class="dropdown-toggle nav-link dropdown-user-link">
                  <span class="avatar avatar-online">
                    <img :src="$store.getters.getProfilePhoto"/>
                    
                  </span>
                  <i class="icon-compass2" v-if="$store.state.isGPS"></i>
                  <span class="user-name">{{ $store.state.userName }}</span>
                </a>
                <div class="dropdown-menu dropdown-menu-right">
                  
                  <router-link class="dropdown-item" :to="{ name: 'profile'}" style="white-space: normal;">
                    <i class="icon-head"></i> {{ $t('titles.profile')}}
                  </router-link>
                  
                  <router-link class="dropdown-item" :to="{ name: 'tasks'}" style="white-space: normal;">
                    <i class="icon-clipboard2"></i> {{ $t('titles.tasks')}}
                  </router-link>
                  
                  <!--<a class="dropdown-item"><i class="icon-calendar5"></i> Calender</a>-->
                  <div class="dropdown-divider"></div>
                  <a class="dropdown-item" @click="fullscr()" ref="fullscr"><i class="icon-enlarge2"></i> Fullscreen</a>
                  <a class="dropdown-item" v-if="$store.getters.getAdmin" @click="showErrors()"><i class="icon-pacman"></i> Errors</a>
                  <a class="dropdown-item" @click="LogOut"><i class="icon-power3"></i> {{ $t('titles.logout')}}</a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
  </nav>

</template>
<script>
    export default {
        data(){
            return{
                //vertical-menu.css
                big_logo: require("../../assets/pictures/me_logo_dark_big.png"),
                small_logo: require("../../assets/pictures/me_logo_small.png"),
            }
        },
        computed:{
            /*isBurgerActive() {
                return this.$store.getters.getNavOpen;
            }*/
            listLanguages(){
              let arrLang = [];
              for (let i = 0; i < this.$i18n.availableLocales.length; i++) {
                arrLang.push({id: this.$i18n.getLocaleMessage(this.$i18n.availableLocales[i]).lang.id, lang: this.$i18n.availableLocales[i]});
              }
              arrLang.sort(function(obj1, obj2) { return obj1.id-obj2.id;});
              return arrLang;
            }
        },
        methods: {
          getFromLocal(key, lang){
            return this.$i18n.tc(key, lang);
          },
          LogOut(){
            this.clearUserInfo();
            this.$router.push({name: 'login'});
          },
          
        },
        mounted(){
        }
    }
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/menu/Navbar.vue